import { defineComponent as _defineComponent } from 'vue'
import LineItemReference from '@/ui/shared/LineItemReference.vue';
import { useValidator } from '@/core/app.service';
import { store } from '@/store';
import { computed, nextTick, ref, watch } from 'vue';
import productService from '@/services/product.service';
import { useImpersonation } from '@/store/impersonation.composable';
import { debounce } from 'lodash';


export default /*#__PURE__*/_defineComponent({
  __name: 'QuickOrderTableRow',
  props: {
    result: null,
    index: null,
    allowPurchase: { type: Boolean },
    dateSort: { type: Boolean },
    asyncDone: { type: Boolean }
  },
  emits: ['toggleDateSort'],
  setup(__props: any, { emit }) {

const props = __props as {
    result: QuickOrderSearchViewObject,
    index: number,
    allowPurchase: boolean,
    dateSort: boolean,
    asyncDone?: boolean
}





const isBasketLocked = computed<boolean>(() => store.getters['basket/isBasketLocked']);
const showStock = computed<boolean>(() => store.getters['app/showStock']);
const hideB2BPrices = computed(() => store.getters['hideb2bprices/hideB2BPrices']);
const isQuoteBasketVisible = computed(() => store.getters['app/isQuoteBasketVisible']);

const { canAssignManualDiscount } = useImpersonation();
const reference = ref<string>('');

const discount = ref<string>(props.result.discount);
const customDiscountEnabled = ref<boolean>(false);
const finalDiscount = computed<string>(() => customDiscountEnabled.value ? discount.value : null);

const price = ref<string>(props.result.purchasePrice);

const toggleDate = () => {
    emit('toggleDateSort');
};

function updateReference(input: any) {
    reference.value = input.reference;
}

const $validator = useValidator();

function onAdded(variant) {
    nextTick(() => $validator.reset());
    reference.value = '';
    customDiscountEnabled.value = false;
    discount.value = props.result.discount;
    price.value = props.result.purchasePrice;
}

function toggleCustomDiscount() {
    customDiscountEnabled.value = true;
    discount.value = props.result.discountPercentage.toString();
}

function toggleListImageZoomModal(idx):void {
    listImageZoomModalToggled.value = !listImageZoomModalToggled.value;
}

const listImageZoomModalToggled = ref<boolean>(false);

const fullScreenZoomImages = computed<any[]>(() => {
    return props.result.images.map(img => ({ imageUrl: img.url }));
});

const debounceCalculateDiscountedPrice = debounce(calculateDiscountedPrice, 100);

async function calculateDiscountedPrice() {
    if (customDiscountEnabled.value) {
        const response = await productService.calculateDiscountedPrice({
            variantId: props.result.variantId,
            discountPercent: finalDiscount.value
        });
        price.value = response.discountedPurchasePrice;
    }
}

watch(() => props.result.discount, () => {
    if (!customDiscountEnabled.value) { discount.value = props.result.discount; }
});

watch(() => props.result.purchasePrice, () => {
    if (!customDiscountEnabled.value) { price.value = props.result.purchasePrice; }
});


return { __sfc: true,props, emit, isBasketLocked, showStock, hideB2BPrices, isQuoteBasketVisible, canAssignManualDiscount, reference, discount, customDiscountEnabled, finalDiscount, price, toggleDate, updateReference, $validator, onAdded, toggleCustomDiscount, toggleListImageZoomModal, listImageZoomModalToggled, fullScreenZoomImages, debounceCalculateDiscountedPrice, calculateDiscountedPrice, LineItemReference }
}

})